var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * Get the given attribute from the record
 *
 * @param {Function|string|string[]} attribute function or the attribute name
 * @param {object} object what you want to get the attribute for
 * @param {any} otherArgs any other arguments used by the attribute function
 *
 * @returns {*} returns attribute or evaluates attribute and returns the result
 */
export var objectAttributeResolver = function (attribute, object) {
    var otherArgs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        otherArgs[_i - 2] = arguments[_i];
    }
    if (typeof attribute === 'function') {
        return attribute.apply(void 0, __spread([object], otherArgs));
    }
    return attribute;
};
//# sourceMappingURL=objectAttributeResolver.js.map